<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">

              <h1 class="text-light">{{ $t("page_notfound") }}</h1>
              <p class="text-lead text-white">{{ $t("page_notfound_desc") }}</p>

              <router-link to="/" class="font-weight-bold text-white mt-5">{{ $t("back") }}</router-link>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- Page content -->
   
  </div>
</template>

<script>

export default {
  name: 'not-found'
};
</script>
